export enum ScrollDirection {
  SCROLL_NONE,
  SCROLL_BACKWARD,
  SCROLL_FORWARD,
}

export enum Position {
  TOP,
  RIGHT,
  BOTTOM,
  LEFT,
}

export const OPTIONS_DEFAULT_DOMAIN_TYPE = 'hour';

export const OPTIONS_DEFAULT_SUBDOMAIN_TYPE = 'minute';
export const OPTIONS_DEFAULT_SUBDOMAIN_WIDTH = 10;
export const OPTIONS_DEFAULT_SUBDOMAIN_HEIGHT = 10;
export const OPTIONS_DEFAULT_SUBDOMAIN_GUTTER = 2;
export const OPTIONS_DEFAULT_SUBDOMAIN_RADIUS = 0;
export const OPTIONS_DEFAULT_ANIMATION_DURATION = 200;
export const OPTIONS_DEFAULT_RANGE = 12;
export const OPTIONS_DEFAULT_ITEM_SELECTOR = '#cal-heatmap';
export const OPTIONS_DEFAULT_THEME = 'light';
export const OPTIONS_DEFAULT_LOCALE = 'en';

export const SCALE_BASE_OPACITY_COLOR = 'red';
export const SCALE_BASE_COLOR_SCHEME = 'YlOrBr';
export const SCALE_BASE_COLOR_TYPE = 'quantize';
export const SCALE_BASE_COLOR_DOMAIN = [0, 100];
